import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { CompassProvider } from "../../../contexts/CompassContext";

import { CartView } from "./CartView";
import { CART_ROUTE, SAVED_PRODUCTS_ROUTE } from "./routes";
import { useAccountDropdown } from "./useAccountDropdown";

/**
 * Cart route for the "Saved Products & Cart" prototype. Reproduces the Carts
 * page; saved products live on the dedicated Saved products page, reached via
 * the "Collections" button in the cart header or the account menu.
 */
export default function SavedProductsCartCartPage() {
  const history = useHistory();
  const accountDropdown = useAccountDropdown();

  useEffect(() => {
    document.title = "Saved Products & Cart — Cart";
  }, []);

  return (
    <CompassProvider>
      <CartView
        cartHref={CART_ROUTE}
        onOpenCollections={() => history.push(SAVED_PRODUCTS_ROUTE)}
        accountDropdown={accountDropdown}
      />
    </CompassProvider>
  );
}
